import { PaginationParams } from '../api-calls';
import type { BaseModel } from './common.types';

export interface MediaModel extends BaseModel {
  fileName: string;
  extension: string;
  fileType: string;
  s3Key: string;
  name: string;
  type: MediaType;
  subType?: MediaSubType;
  // Related Entities
  userId?: string;
  visitId?: string;
  commentId?: string;
  visitBarId?: string;
  visitCellarId?: string;
  visitTapId?: string;
  visitFobId?: string;
  visitRemoteCoolerId?: string;
  visitGlassWasherId?: string;
  visitAmsPartId?: string;
  visitFaultInteractionId?: string;
  venueId?: string;
}

export interface MediaData extends MediaModel {
  contentUrl: string;
}

export interface ListMedia extends MediaData {
  createdBy?: string;
}

export interface MediaFileDetails {
  fileName: string;
  fileType: string;
  extension: string;
}

export interface MediaUploadDetails {
  type: MediaType;
  subType?: MediaSubType;
  userId?: string;
  visitId?: string;
  commentId?: string;
  visitBarId?: string;
  visitCellarId?: string;
  visitTapId?: string;
  visitFobId?: string;
  visitRemoteCoolerId?: string;
  visitGlassWasherId?: string;
  visitAmsPartId?: string;
  visitFaultInteractionId?: string;
  venueId?: string;
}

export interface CreateMediaParams extends MediaFileDetails, MediaUploadDetails {
  s3Key: string;
}

export class ListMediaParams extends PaginationParams {
  visitId?: string;
  venueId?: string;
  visitFaultInteractionId?: string;
  type?: MediaType;
}

export interface DeleteMediaParams {
  mediaId: string;
}

export enum MediaType {
  VISIT = 'Visit',
  COMMENT = 'Comment',
  BAR = 'Bar',
  CELLAR = 'Cellar',
  TAP = 'Tap',
  FOB = 'Fob',
  REMOTE_COOLER = 'Remote Cooler',
  GLASS_WASHER = 'Glass Washer',
  AMS_PART = 'Ams Part',
  FAULT_INTERACTION = 'Fault Interaction',
  VENUE = 'Venue',
  REFERENCE_MATERIALS = 'Reference Materials'
}

export enum MediaBarSubType {
  GLASSWARE = 'Glassware',
  NOZZLES = 'Nozzles',
  PERFECT_PINT = 'Perfect Pint',
  LINES_PH = 'Lines Ph',
  TAP_HYGIENE = 'Tap Hygiene',
  FLUSH_WATER_CLEAR = 'Flush Water Clear'
}

export enum MediaCellarSubType {
  FOB_INTERNAL_HYGIENE = 'Fob Internal Hygiene',
  COUPLER_HYGIENE = 'Coupler Hygiene',
  SOCKET_HYGIENE = 'Socket Hygiene',
  BACK_BOARD_HYGIENE = 'Back Board Hygiene',
  CASK_EQUIPMENT_HYGIENE = 'Cask Equipment Hygiene',
  PYTHON = 'Python'
}

export type MediaSubType = MediaBarSubType | MediaCellarSubType;

export type MediaSortingFields = 'createdAt' | 'fileName' | 'extension' | 'name' | 'type' | 'subType' | 'createdBy';
